export class PatchInvoiceableItemRequest {
    public  Optype: string;

    public  ColName: string;

    public  Value: string;
constructor(optype: string, colname: string, value: string) {
    this.Optype = optype;
    this.ColName = colname;
    this.Value = value;
}
}
